<template>
  <div class="card-wraper">
    <div class="box-card">
      <!-- <div slot="header" class="card-header">
        <span>{{ `${row} * ${column}` }}</span>
      </div> -->
        <div class="card-select">
        <div
          class="card-box"
          v-for="(item, index) in Number(column)"
          :key="index"
        >
          <el-select
            v-if="!disabled"
            v-model="brandSelectedSelf[index]"
            placeholder="选择子品牌"
            filterable
            size="mini"
            :style="{paddingRight:item < Number(column) ? '5px' : '0px'}"
          >
            <template v-for="item in subBrandList">
              <!-- 混堆设计时选择子品牌 不允许再选择‘混堆’ 因此剔除 -->
              <el-option
                v-if="
                  item.parentBrandCode !== 'BUDHD'
                "
                :key="item.abiBrandId"
                :label="item.abiBrandDesc"
                :value="
                  `${item.abiBrandCode},${item.abiBrandDesc},${item.tradeStackColor}`
                "
              >
              </el-option>
            </template>
          </el-select>
          <div
            class="card-item"
            :style="{ backgroundColor: brandSelectedSelf[index] ? getBrandInfo('color', index) : '#fff' }"
            v-for="rItem in Number(row)"
            :key="rItem"
          >
            {{ brandSelectedSelf[index] ? getBrandInfo("name", index) : "" }}
          </div>
        </div>
      </div>
      <div class="card-operte">
        <el-button type="primary" @click="cancelDesign">取消</el-button>
        <el-button
          v-if="!disabled"
          type="danger"
          @click="handleConfirmDesign"
          >确定生成</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'stack-design-dialog',
  props: {
    row: {
      type: String,
      default: ''
    },
    column: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    brandSelected: {
      type: Array,
      default: () => {
        return []
      }
    },
    subBrandList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  watch: {
    brandSelected () {
      console.log('watch brandSelected')
      this.brandSelectedSelf = this.brandSelected.slice(0)
    }
  },
  data () {
    return {
      brandSelectedSelf: this.brandSelected.slice(0),
      brandSelectedOrigin: []
    }
  },
  methods: {
    // 获取品牌信息
    getBrandInfo (type, index) {
      if (!this.brandSelectedSelf.length) return
      if (type === 'color') {
        return this.brandSelectedSelf[index] ? this.brandSelectedSelf[index].split(',')[2] : 0
      }
      if (type === 'name') {
        return this.brandSelectedSelf[index] ? this.brandSelectedSelf[index].split(',')[1] : 0
      }
    },
    cancelDesign () {
      this.$emit('handleCancelDesign')
    },
    // 确认生成
    // 拷贝所选品牌改变前的数组，当用户点击取消时，将数组重置回改变前的状态
    handleConfirmDesign () {
      if (this.checkData()) {
        // this.brandSelectedOrigin = this.brandSelectedSelf.slice(0)
        this.$emit('handleConfirmDesign', this.brandSelectedSelf)
      }
    },
    checkData () {
      let hasSelectedAll = this.brandSelectedSelf.length === Number(this.column)
      if (!hasSelectedAll) {
        this.$message.warning('请选择混堆子品牌')
        return false
      }
      // 判断所选品牌是不是所有都相同
      if (this.brandSelectedSelf.length === 1) return true
      let hasAllSomeBrand = true
      for (let i = 0; i < (this.brandSelectedSelf.length - 1); i++) {
        if (this.brandSelectedSelf[0] !== this.brandSelectedSelf[i + 1]) {
          hasAllSomeBrand = false
          break
        }
      }
      if (hasAllSomeBrand) {
        this.$message.warning('所选子品牌不能唯一')
        return false
      }
      return true
    }
  }
}
</script>

<style lang="scss" scoped>
.card-wraper {
    position: relative;
    width: 100%;
    height: 100%;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    pointer-events: none;
  }
  .box-card {
    // width: 700px;
    pointer-events: auto;
    z-index: 2;
    width: 100%;
    .card-header {
      text-align: center;
      line-height: 40px;
      font-size: 18px;
      font-weight: 600;
      color: #333;
      span {
        display: inline-block;
        width: 50%;
      }
    }
  .card-select {
      display: flex;
      flex-wrap: nowrap;
      overflow-x: scroll;
      max-height: 500px;
      padding-bottom: 20px;
      min-width: 350px;
    }
    .card-box{
      margin:auto;
    }
  }
  .card-item {
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    width: 100px;
    height: 80px;
    margin: 10px auto 0;
    line-height: initial;
    text-align: center;
    color: #fff;
    border: 1px solid #c0c4cc;
    border-radius: 10px;
  }
  .card-operte {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
  }
</style>
